module.exports = __webpack_public_path__ + "img/quote-right.eab03068.svg";